import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { trackEvent } from '../lib/analytics';
import { useIsClient } from '../lib/hooks/useHydration';

interface EventFooterProps {
  onRsvpClick: () => void;
  isRsvpEnabled: boolean;
  hasResponded: boolean;
  buttonText?: string;
  isModalOpen?: boolean;
}

export default function EventFooter({ 
  onRsvpClick, 
  isRsvpEnabled, 
  hasResponded, 
  buttonText,
  isModalOpen = false
}: EventFooterProps) {
  const { t } = useTranslation();
  const [showAppButton, setShowAppButton] = useState(false);
  const isClient = useIsClient();

  useEffect(() => {
    if (isClient) {
      setShowAppButton(window.location.pathname.includes('/i/'));
    }
  }, [isClient]);

  // Early return after all hooks are called
  if (!isRsvpEnabled || isModalOpen) return null;

  const getButtonText = () => {
    if (buttonText) return buttonText;
    return hasResponded ? t('event.rsvp.updateRsvp') : t('event.rsvp.title');
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-200 z-[60]">
      <div className="max-w-2xl mx-auto flex gap-4">
        {isClient && showAppButton && (
          <button
            onClick={() => {
              const inviteId = window.location.pathname.split('/').pop();
              trackEvent('open_in_app_click', {
                invite_id: inviteId,
                source: 'event_footer',
                has_responded: hasResponded,
              });
              window.location.href = `https://in.invitd.us/sq6nusKPpZb?saveEvent=true&inviteID=${inviteId}`;
            }}
            className="w-[65%] bg-gray-100 text-gray-800 py-3 px-6 rounded-lg font-medium hover:bg-gray-200 transition-colors flex items-center justify-center gap-2"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
            </svg>
            Open in App
          </button>
        )}
        <button
          onClick={onRsvpClick}
          className={`${isClient && showAppButton ? 'w-[35%]' : 'w-full'} bg-blue-600 text-white py-3 px-6 rounded-lg font-medium hover:bg-blue-700 transition-colors`}
        >
          {getButtonText()}
        </button>
      </div>
    </div>
  );
}